"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Global = (function () {
    var instance;
    function init() {
        return {
            modules: {},
            callbacks: {},
            callbackId: 0
        };
    }
    return {
        getInstance: function () {
            if (!instance) {
                instance = init();
            }
            return instance;
        }
    };
})();
